import { Link, useLocation } from 'react-router-dom';

export default function WithSubnavigation({ darkmode = true }: { darkmode: boolean }) {
  return (
    <DesktopNav />
  );
}

const DesktopNav = () => {
  const location = useLocation();
  return (
    <ul className="nav-list grid grid-cols-7 content-width mx-auto text-center">
      {NAV_ITEMS.map((navItem) => location.pathname !== navItem.href ? (
        <li className="nav-item uppercase py-4" key={navItem.href} >
          <Link to={navItem.href}>
            {navItem.label}
          </Link>
        </li>
      ) : null)}
    </ul>
  );
};

interface NavItem {
  label: string;
  href: string;
  hidden: string[];
}

const NAV_ITEMS: Array<NavItem> = [
  {
    label: 'HOME',
    href: 'https://beyonce.com/',
    hidden: [],
  },
  {
    label: 'TOUR',
    href: 'https://beyonce.com/tour',
    hidden: [],
  },
  {
    label: 'SHOP',
    href: 'https://shop.beyonce.com',
    hidden: ['/privacy-policy', '/terms-and-conditions'],
  },
  {
    label: '',
    href: '',
    hidden: [],
  },
  // {
  //   label: 'MUSIC',
  //   href: 'https://music.beyonce.com/',
  //   hidden: ['/'],
  // },
  {
    label: 'PARFUM',
    href: 'https://parfum.beyonce.com/',
    hidden: [],
  },
  {
    label: 'CÉCRED',
    href: 'https://cecred.com/',
    hidden: [],
  },
  {
    label: 'SIRDAVIS',
    href: 'https://www.sirdavis.com/?utm_source=msb&utm_medium=community&utm_campaign=SIRDAVIS_WS_USA_SIRDAVISBRLAUNCH_WHI_MASTERBRAND_SIRDAVIS_AW',
    hidden: [],
  },
];